


























import Vue from 'vue'
import { Store } from 'vuex'
import { rgbaConverter, openModal } from './helpers/helpers'
import { findInitialVisibleSlideId } from './../store/state'
import NextButton from './NextButton.vue'
import Slide from './Slide.vue'
export default Vue.extend({
  name: 'OpenModal',
  components: { Slide, NextButton },
  data() {
    return {
      defaultNextButton: true
    }
  },
  computed: {
    storeState(): IState {
      return (this.$store as Store<IState>).state
    },
    buttonText(): string {
      return this.storeState.openModalButtonText || "Kontakt"
    },
    buttonStyle(): IButton {
      return this.storeState.slidesConfig.submitButton
    },
    buttonBackground(): string {
      return this.defaultNextButton
        ? rgbaConverter(this.buttonStyle.normalStyle.background.color)
        : rgbaConverter(this.buttonStyle.hoverStyle.background.color)
    },
    buttonTextColor(): string {
      return this.defaultNextButton
        ? rgbaConverter(this.buttonStyle.normalStyle.textColor)
        : rgbaConverter(this.buttonStyle.hoverStyle.textColor)
    },
    buttonBorder(): string {
      return this.defaultNextButton
        ? `${ this.buttonStyle.normalStyle.borderWidth }px solid ${rgbaConverter(this.buttonStyle.normalStyle.borderColor)}`
        : `${ this.buttonStyle.hoverStyle.borderWidth }px solid ${rgbaConverter(this.buttonStyle.hoverStyle.borderColor)}`
    },
    slide(): TSlideResult {
      return (this.$store as Store<IState>).getters.getSlideById(
        findInitialVisibleSlideId()
      )
    },
    isOpenedByCards(): boolean {
      return this.storeState.openModalByCards
    },
    buttonId(): string {
      return `${this.$store.state.clickFlowID}-open-modal-button`
    },
    visibleSlideId(): string {
      return this.storeState.visibleSlideId
    },
    visibleSlide(): TSlides {
      return (this.$store as Store<IState>).getters.getSlideById(
        this.visibleSlideId
      )
    },
    showNextButton(): boolean {
      if (this.visibleSlide.targetSlideId === undefined || this.isSubmitSlide) {
        return false
      }

      switch (this.visibleSlide.type) {
        case 'select':
          return this.visibleSlide.multipleSelect || this.showNextButtonOnSlide
        case 'freeField':
          return true
        default:
          throw new Error('Could not match visibleSide.type.')
      }
    },
    showNextButtonOnSlide(): boolean {
      return this.storeState.slidesConfig.nextButton.showOnSlide
    },
    isSubmitSlide(): boolean {
      return this.visibleSlide.type === 'freeField'
        ? this.visibleSlide.fields.some(
            field => field.type === 'input' && field.inputType === 'submit'
          )
        : false
    }
  },
  methods: {
    click() {
      if (this.storeState.openModalByCards) {
        this.nextSlide()
      }
      if (!this.storeState.showModal) {
        openModal()
      }
    },
    buttonHover() {
      this.defaultNextButton = !this.defaultNextButton
    },
    nextSlide() {
      this.$store.commit('visibleSlideId', this.slide.targetSlideId)
    }
  }
})
